const snack = require('../../../../../components/snack/snack')

export function start( detail ){ 
  
 
  snackBody[detail.id].start(detail.addTitle)

  detail.html = snackBody[detail.id]
  snack.start(detail)

}

const snackBody = {

  reportDownloadError: {
      title: '',
      btn: '',
      class:``,
      dataDetail:``,


      start: function(){
        this.title   = 'The system activity report could not be generated'
        this.btn     = ''

      }
  },

	passwordUpdated: { 
        title: '', 
        btn: '',
        class:``,
        dataDetail:``,


        start: function(){  
          this.title   = 'The password has been updated'        //language.start('inProgress')     
          this.btn     = ''        //language.start('inProgress')     

        }
      },

  passwordUpdateError: { 
        title: '', 
        btn: '',
        class:``,
        dataDetail:``,


        start: function(){  
          this.title   = 'An error happend updating the password'        //language.start('inProgress')     
          this.btn     = ''        //language.start('inProgress')     

        }
  },

  errorSendEmail: { 
      title: '', 
      btn: '',
      class:``,
      dataDetail:``,


      start: function(addTitle){  
        this.title   = addTitle       
        this.btn     = ''         

      }
    },

    emailWasSent: { 
      title: '', 
      btn: '',
      class:``,
      dataDetail:``,

      start: function(){  
        this.title   = 'Email was sent successfully'        //language.start('inProgress')     
        this.btn     = ''        //language.start('inProgress')     

      }
    },



    

}
